import { render, staticRenderFns } from "./ContactStep.vue?vue&type=template&id=9bea2d54&lang=pug"
import script from "./ContactStep.vue?vue&type=script&lang=js"
export * from "./ContactStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TypedDateInput: require('/home/docker/code/frontend/components/TypedDateInput.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default,AddressSearch: require('/home/docker/code/frontend/components/AddressSearch.vue').default})
